<template>
  <div class="tile is-parent is-vertical">
    <p class="formtitle">Turmas >> {{formtitle}}</p>

    <article class="tile is-child notification formbox">
      <form @submit.prevent="validate">
        <b-field grouped group-multiline>
          <b-field
            class="column is-4"
            label="nome"
            :type="{'is-danger': errors.has('nome')}"
            :message="errors.first('nome')"
          >
            <b-input v-model="turma.nome" v-validate="'required'" name="nome"></b-input>
          </b-field>
        </b-field>

        <div class="control has-text-centered">
                    <b-button class="button cancelbutton">Cancelar</b-button>
          <button type="submit" class="button updatebutton" :disabled="!isFormValid">{{buttom}}</button>
        </div>
      </form>
    </article>
  </div>
</template>
<script>
import DiretorService from "@/services/DiretorService";
import store from "@/store";

export default {
  data() {
    return {
      diretor: []
    };
  },

  name: "turmaForm",
  props: ["turma", "buttom", "formtitle"],
  methods: {
    validate() {
      this.$validator.validateAll().then(result => {
        if (result) {
          let self = this;

          this.$emit("formSubmit", self.turma, () => {});
        }
      });
    }
  },
  components: {},
  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some(key => this.fields[key].invalid);
    }
  },
  created() {
    DiretorService.Info(store.getters.cargo_id).then(result => {
      this.diretor = result.data;
      this.turma.escola_id = this.diretor.escola.id;
    });
  }
};
</script>
